// 自分がスコアの対象外（運営・オブザーバー）のときの案内。
// リーダーボードには載らないので、自分のベストスコアだけを見せる。

export const KIND_LABELS: Record<string, string> = {
  participant: "参加者",
  staff: "運営",
  observer: "オブザーバー",
};

export interface OwnSubmission {
  status: string;
  score?: number | null;
}

/** 自分の採点済みの投稿のうちベストのスコア。無ければ null */
export const bestOwnScore = (
  submissions: readonly OwnSubmission[] | null | undefined,
  ascending: boolean
): number | null => {
  let best: number | null = null;
  for (const s of submissions ?? []) {
    if (s.status !== "success" || s.score === null || s.score === undefined) continue;
    if (!Number.isFinite(s.score)) continue;
    if (best === null || (ascending ? s.score < best : s.score > best)) best = s.score;
  }
  return best;
};

/** 「あなたは運営としてスコアの対象外です」。対象なら null */
export const unscoredMessage = (
  myScored: boolean | null | undefined,
  myKind: string | null | undefined
): string | null => {
  if (myScored !== false) return null;
  const label = KIND_LABELS[myKind ?? ""];
  return label && myKind !== "participant"
    ? `あなたは${label}としてスコアの対象外です`
    : "あなたはスコアの対象外です";
};
